export default {
  namespaced: true,

  state: () => ({
    categories: {
      rows: [],
    },
    // new endpoint
    categories2: {
      data: [],
      links: {},
      meta: {},
    },
    category: {},
    isLoading: false,
  }),

  getters: {
    categoryList: state => {
      const categories = []
      state.categories.rows.forEach(c1 => {
        categories.push({ id: c1.id, name: c1.name })
        c1.children.forEach(c2 => {
          categories.push({ id: c2.id, name: `${c1.name} / ${c2.name}` })
        })
      })
      return categories
    },
    subCategoryList: state => {
      const categories = []
      state.categories.rows.forEach(c1 => {
        c1.children.forEach(c2 => {
          categories.push({ id: c2.id, name: `${c1.name} / ${c2.name}` })
        })
      })
      return categories
    },
  },

  mutations: {
    SET_CATEGORY_LIST(state, payload) {
      state.categories = payload
    },
    SET_CATEGORIES(state, payload) {
      state.categories2 = payload
    },
    SET_CATEGORY(state, payload) {
      state.category = payload
    },
    SET_LOADING(state, value) {
      state.isLoading = value
    },
  },

  actions: {
    async getCategoryList({ commit }, { isRoot = undefined } = {}) {
      try {
        const url = '/v1/categories'

        const response = await this._vm.$http.get(url, {
          params: {
            'filter[is_root]': isRoot,
          },
        })

        commit('SET_CATEGORY_LIST', response.data.data)

        return response.data.data
      } catch (error) {
        return error
      }
    },
    // new endpoint
    async getCategories({ commit }, { page = null, keyword = '' } = {}) {
      try {
        commit('SET_LOADING', true)
        const url = `/v1/admin/categories?filter[name]=${keyword}`

        const response = await this._vm.$http.get(url, { params: { page } })

        commit('SET_CATEGORIES', response.data)

        commit('SET_LOADING', false)
        return response.data
      } catch (error) {
        commit('SET_LOADING', false)
        return error
      }
    },
    async getCategory({ commit }, { id }) {
      try {
        const url = `/v1/admin/categories/${id}`

        const response = await this._vm.$http.get(url)

        commit('SET_CATEGORY', response.data)

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Memuat Data!',
        }, { root: true })
        return error
      }
    },
    async createCategory({ commit }, data) {
      try {
        const url = '/v1/admin/categories'

        const formData = new FormData()
        formData.append('icon', data.iconFile)
        formData.append('name', data.name)
        formData.append('slug', data.slug)
        formData.append('parent_id', data.parent_id || '')
        formData.append('article', data.article || '')
        formData.append('order', data.order || '')

        const response = await this._vm.$http.post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menambahkan Kategori!',
        }, { root: true })

        return response.data
      } catch (error) {
        let errorMessage = error.message

        if (error.response.status === 422) {
          const { errors } = error.response.data
          if (Object.prototype.hasOwnProperty.call(errors, 'slug')) {
            errorMessage = 'Format slug salah atau sudah digunakan!'
          }
        }
        commit('response/SET_ERROR', {
          message: errorMessage,
        }, { root: true })

        throw new Error(error)
      }
    },
    async updateCategory({ commit }, { categoryId, data }) {
      try {
        const url = `/v1/admin/categories/${categoryId}`

        const formData = new FormData()
        if (data.iconFile) {
          formData.append('icon', data.iconFile)
        }
        formData.append('name', data.name)
        formData.append('slug', data.slug)
        formData.append('parent_id', data.parent_id || '')
        formData.append('article', data.article || '')
        formData.append('order', data.order || '')

        formData.append('_method', 'PUT')

        const response = await this._vm.$http.post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Mengubah Kategori!',
        }, { root: true })

        return response.data
      } catch (error) {
        let errorMessage = error.message

        if (error.response.status === 422) {
          const { errors } = error.response.data
          if (Object.prototype.hasOwnProperty.call(errors, 'slug')) {
            errorMessage = 'Format slug salah atau sudah digunakan!'
          }
        }

        commit('response/SET_ERROR', {
          message: errorMessage,
        }, { root: true })

        throw new Error(error)
      }
    },
    async deleteCategory({ commit, dispatch }, { categoryId }) {
      try {
        const url = `/v1/admin/categories/${categoryId}`

        const response = await this._vm.$http.delete(url)

        dispatch('getCategories')

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menghapus Kategori!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Menghapus Kategori!',
        }, { root: true })

        return error
      }
    },
  },
}
